import { createAsyncAction } from "typesafe-actions";
import { IError } from "..";
import { IURLResponse } from "./types";

export const fetchURL = createAsyncAction(
  "FETCH_URL_START",
  "FETCH_URL_SUCCESS",
  "FETCHURL_FAILURE",
)<void, { data: IURLResponse; url: string }, IError>();
